// MOMERY CUSTOM: Habitat 14 compatible cart quantity validation.
(function (root) {
  'use strict';

  const QUANTITY_SELECTOR = 'input.qty[type="number"][name="updates[]"]';

  function integer(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function minimumOf(input) {
    return integer(input?.getAttribute?.('min')) ?? 1;
  }

  function maximumOf(input) {
    const dataMaximum = integer(input?.dataset?.max);
    if (dataMaximum !== null) return dataMaximum;

    const nativeMaximum = integer(input?.getAttribute?.('max'));
    return nativeMaximum ?? Infinity;
  }

  function clampValue(input, value) {
    const minimum = minimumOf(input);
    const maximum = maximumOf(input);
    const parsed = integer(value);
    return Math.min(Math.max(parsed ?? minimum, minimum), maximum);
  }

  function validationMessage(input, value) {
    const parsed = integer(value);
    const minimum = minimumOf(input);
    const maximum = maximumOf(input);

    if (parsed === null) return 'Bitte eine Zahl eingeben.';
    if (parsed < minimum) return `Mindestens ${minimum} Stück.`;
    if (parsed > maximum) return `Nur bis ${maximum} Stück möglich.`;
    return '';
  }

  function syncNativeMaximum(input) {
    const dataMaximum = integer(input?.dataset?.max);
    if (dataMaximum !== null) input.setAttribute('max', String(dataMaximum));
  }

  function syncQuantityInputs(scope) {
    const queryRoot = scope?.querySelectorAll ? scope : root.document;
    queryRoot?.querySelectorAll?.(QUANTITY_SELECTOR).forEach(syncNativeMaximum);
  }

  const api = {
    clampValue,
    maximumOf,
    minimumOf,
    syncNativeMaximum,
    syncQuantityInputs,
    validationMessage,
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.MomeryCartQuantityGuard = api;

  const document = root.document;
  if (!document || root.__momeryCartQuantityGuard) return;
  root.__momeryCartQuantityGuard = true;

  function quantityInputFromEvent(event) {
    const target = event.target;
    return target?.matches?.(QUANTITY_SELECTOR) ? target : null;
  }

  document.addEventListener(
    'input',
    (event) => {
      const input = quantityInputFromEvent(event);
      if (!input) return;

      const digits = input.value.replace(/\D/g, '');
      if (digits !== input.value) input.value = digits;
      const message = digits ? validationMessage(input, digits) : '';
      input.setCustomValidity(message);
      if (message) input.reportValidity();
    },
    true
  );

  // Capture runs before Habitat/FAC bubble listeners, so they receive one normalized change.
  document.addEventListener(
    'change',
    (event) => {
      const input = quantityInputFromEvent(event);
      if (!input) return;

      syncNativeMaximum(input);
      input.value = String(clampValue(input, input.value));
      input.setCustomValidity('');
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const input = quantityInputFromEvent(event);
      if (input && event.key === 'Enter') {
        event.preventDefault();
        input.blur();
      }
    },
    true
  );

  syncQuantityInputs(document);
  document.addEventListener('shopify:section:load', (event) => syncQuantityInputs(event.target));
  document.addEventListener('line-item:change:end', () => syncQuantityInputs(document));
  document.addEventListener('cart:refresh', () => syncQuantityInputs(document));
})(typeof window !== 'undefined' ? window : globalThis);
